import { DatePicker } from "@mui/lab";
import { TextField } from "@mui/material";
import { Dispatch, RefObject, useState } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  date: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const DateInput = ({ handleErrorRefs, dispatch, loading, date }: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const handleError = () => {
    setError(date.error);
    setMessage(date.message);
  };
  handleErrorRefs.current?.push(handleError);

  return (
    <DatePicker
      disabled={loading}
      minDate={new Date()}
      label={"Datum"}
      onChange={(e, v) => {
        dispatch({ type: FormInputs.date, payload: e });
        handleError();
      }}
      inputFormat="dd/MM/y"
      value={date.input as Date}
      renderInput={(params) => (
        <TextField {...params} fullWidth error={error} helperText={message} />
      )}
      // onBlur={handleError}
    />
  );
};

export default DateInput;
